import { type ReactNode, useEffect } from 'react';
import { useLocation } from 'react-router';

import { useI18n } from '#/i18n/hooks/useI18n';
import { HORIZON_ENABLED } from '#/rendering/state/renderingState';

type Props = {
  title: string;
  description?: string;
  children: ReactNode;
};

export function RouteModule({ title, description, children }: Props) {
  const { i18n } = useI18n();
  const location = useLocation();
  const isInStaffRoute =
    location.pathname.startsWith('/staff') ||
    location.pathname.startsWith('/cms');

  const affixedTitle = isInStaffRoute ? '🧑‍💼 ' + title : `${title} - Idealist`;

  useEffect(() => {
    if (HORIZON_ENABLED) return;
    document.title = affixedTitle;
  }, [affixedTitle]);

  // oxlint-disable-next-line jsx-no-useless-fragment
  if (!HORIZON_ENABLED) return <>{children}</>;

  return (
    <>
      <title>{affixedTitle}</title>
      <meta property="og:title" content={title} />

      <meta
        name="description"
        content={
          description ??
          i18n(
            'Idealist connects millions of idealists – people who want to do good – with opportunities for action and collaboration all over the world.',
          )
        }
      />

      <meta name="twitter:card" content="summary_large_image" />
      <meta property="og:image" content="/static/images/og-image.jpg" />

      {children}
    </>
  );
}
